export const routes = (prefix=`outpatient`) => [
    {
        path: `/${prefix}/triage/:patientID/:visitNO`,
        name: `${prefix}.triage.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.triage.create`,
                PageDescription: "Patient Management - Triage",
            },
        },
    },
    {
        path: `/${prefix}/triage/:patientID/:visitNO/:encounterID`,
        name: `${prefix}.encounter.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.encounter.create`,
                PageDescription: "Patient Management - Triage (Create Encounter)",
            },
        },
    },
    {
        path: `/${prefix}/triage/:patientID/:visitNO/:encounterID/:triageID`,
        name: `${prefix}.triage.edit`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.triage.edit`,
                PageDescription: "Patient Management - Triage (Create Encounter)",
            },
        },
    },
];
